module.exports = __webpack_public_path__ + "static/media/Dino Tracker.bc2ae468.jpg";